import _ from 'lodash';
import { toTitleCase, getCategoryComponents, getDimensionIdForTalent } from './index';

const TALENT_CATEGORIES = ['motivation', 'interaction', 'cognition', 'execution'];

export function getSevenImperative(id){
  return _.find(getSevenImperatives(), {id});
}

export function getSevenImperatives(){
  return [
    {
      id: '1',
      name: 'Who is the Buyer?',
      summaryQuestion: 'List the buyer',
      tasks: [
        {
          id: '111',
          imperative: '1',
          text: 'Buyer confirmed?'
        },{
          id: '112',
          imperative: '1',
          text: 'Organizational needs and objectives confirmed?'
        },{
          id: '113',
          imperative: '1',
          text: 'Budget confirmed?'
        },{
          id: '114',
          imperative: '1',
          text: 'Buyer can enthusiastically sell our Value Proposition'
        },{
          id: '115',
          imperative: '1',
          text: 'Do you have access to the Buyer?'
        }
      ],
      questions: [
        {
          id: '121',
          text: 'How will you be measured on this initiative?',
        },{
          id: '122',
          text: 'What would success look like on this initiative?',
        },{
          id: '123',
          text: 'Could explain the procurement process at your company? Who needs to have input on this initiative? Who will ultimately sign this contract?',
        },{
          id: '124',
          text: 'Review publicly available data to review executive names?',
        }
      ]
    },{
      id: '2',
      name: 'Who are the Influencers?',
      summaryQuestion: 'List all influencers',
      tasks: [
        {
          id: '211',
          imperative: '2',
          text: 'All Influencers confirmed?'
        },{
          id: '212',
          imperative: '2',
          text: 'Do we have access to all Influencers?'
        },{
          id: '213',
          imperative: '2',
          text: 'Influencers are aligned on business goals and objectives?'
        },{
          id: '214',
          imperative: '2',
          text: 'All Influencers can enthusiastically support our Value Proposition?'
        },{
          id: '215',
          imperative: '2',
          text: 'Has one or more of the Influencers become an advisor?'
        }
      ],
      questions: [
        {
          id: '221',
          text: 'Can you explain the buying or procurement process at your company?',
        },{
          id: '222',
          text: 'With clients of similar complexity we typically have discovery calls with the head of IT, HR, Operations etc... can you help make those connections?',
        },{
          id: '223',
          text: 'This initiative cuts across various departments, how can I help you communicate the goals, objectives and ROI to your colleagues?',
        }
      ]
    },{
      id: '3',
      name: 'Who are we competing against, and why?',
      summaryQuestion: 'Summarize strategy',
      tasks: [{
        id: '311',
        imperative: '3',
        text: 'I know who our competition is?',
      },{
        id: '312',
        imperative: '3',
        text: 'Buyer has shared their perception of competition?',
      },{
        id: '313',
        imperative: '3',
        text: 'Competition has an existing relationship with Prospect?',
      },{
        id: '314',
        imperative: '3',
        text: 'I understand why each Competitor is at the table?',
      },{
        id: '315',
        imperative: '3',
        text: 'Buyer and Influencers are aligned on most important Partner attributes?',
      }],
      questions: [{
        id: '321',
        text: 'What other potential solutions to this opportunity/problem is your company considering? Have you outlined the pros and cons of each alternative?',
      },{
        id: '322',
        text: 'What functionality or features have you seen in the marketplace that you are impressed with?',
      },{
        id: '323',
        text: 'Who do you currently consider to be your top partner/vendor? Why?',
      }]
    },{
      id: '4',
      name: 'Why will we win?',
      summaryQuestion: 'Summarize strategy',
      tasks: [{
        id: '411',
        imperative: '4',
        text: 'I clearly understand prospect’s needs and objectives?',
      },{
        id: '412',
        imperative: '4',
        text: 'Prospect has shared Organizational Pain Points?',
      },{
        id: '413',
        imperative: '4',
        text: 'Prospect is advising me on a Win Strategy?',
      },{
        id: '414',
        imperative: '4',
        text: 'I understand our position against our Competitors?',
      },{
        id: '415',
        imperative: '4',
        text: 'Prospect has shared decision making/procurement process?',
      }],
      questions: [{
        id: '421',
        text: 'How will you be measured on this initiative?',
      },{
        id: '422',
        text: 'What does success look like on this project?',
      },{
        id: '423',
        text: 'Do you have all the information you need from us to  confidently support this decision?',
      }]
    },{
      id: '5',
      name: 'Why will we lose?',
      summaryQuestion: 'Summarize risks',
      tasks: [{
        id: '511',
        imperative: '5',
        text: 'I can outline all risks on this opportunity?',
      },{
        id: '512',
        imperative: '5',
        text: 'I have a clear follow up plan to overcome all risks?',
      },{
        id: '513',
        imperative: '5',
        text: 'Buyer is sharing internal objections?',
      },{
        id: '514',
        imperative: '5',
        text: 'We have reviewed Terms and Conditions and believe there are no deal breakers?',
      },{
        id: '515',
        imperative: '5',
        text: 'Buyer is being transparent about our position?',
      }],
      questions: [{
        id: '521',
        text: 'Are all key business influencers aligned on this decision? If not, how can we help get them there?',
      },{
        id: '522',
        text: 'Is there anything about our value proposition that we have worked on together that doesn’t solve your problems or that you are unsure of?',
      },{
        id: '523',
        text: 'Is there any reason we wouldn\'t win your business?',
      }]
    },{
      id: '6',
      name: 'When will decision be made?',
      summaryQuestion: 'Summarize timeline',
      tasks: [{
        id: '611',
        imperative: '6',
        text: 'Decision date confirmed?',
      },{
        id: '612',
        imperative: '6',
        text: 'Legal and procurement engaged?',
      },{
        id: '613',
        imperative: '6',
        text: 'Project Kickoff date agreed?',
      },{
        id: '614',
        imperative: '6',
        text: 'Prospect has identified Kickoff Team?',
      },{
        id: '615',
        imperative: '6',
        text: 'Prospect is assisting in closing process?',
      }],
      questions: [{
        id: '621',
        text: 'When is the business counting on impact/ROI from this initiative? We need to sign and kickoff by _____ date to realize?',
      },{
        id: '622',
        text: 'How can we be helpful in facilitating your procurement process?',
      },{
        id: '623',
        text: 'We both have a number of moving parts at each of our respective organizations. Can we create a schedule of steps and dates so that we can keep the legal and procurement teams moving?',
      }]
    },{
      id: '7',
      name: 'What have we taught them?',
      summaryQuestion: 'Summarize teachings',
      tasks: [{
        id: '711',
        imperative: '7',
        text: 'I have developed rapport and credibility with Prospect?',
      },{
        id: '712',
        imperative: '7',
        text: 'I have a deep understanding of my Prospect’s challenges?',
      },{
        id: '713',
        imperative: '7',
        text: 'My Prospect believes we can meet their base expectations?',
      },{
        id: '714',
        imperative: '7',
        text: 'My Prospect has called to seek my guidance and counsel?',
      },{
        id: '715',
        imperative: '7',
        text: 'I believe if asked, my Prospect would say the sales process was so effective they would have paid for our counsel?',
      }],
      questions: [{
        id: '721',
        text: 'People buy from those they trust, like and learn from.',
      },{
        id: '722',
        text: 'Prospects must feel listened to.',
      },{
        id: '723',
        text: 'Core needs must be met before you can move to advisory selling.',
      },{
        id: '724',
        text: 'Be an expert in your field or craft.',
      },{
        id: '725',
        text: 'Position your company’s subject matter experts to add value.',
      },{
        id: '726',
        text: 'Practice your story selling skills.'
      }]
    }
  ]
}

export function getImperativesStages(){
  return {
    stages: [{
      id: '1',
      name: 'qualify',
    },{
      id: '2',
      name: 'discovery',
    },{
      id: '3',
      name: 'alliance'
    },{
      id: '4',
      name: 'close'
    }],

    objectives: [{
      id: '101',
      stage: '1',
      imperativeId: null,
      text: 'Initial call and discovery'
    },{
      id: '102',
      stage: '1',
      imperativeId: null,
      text: 'Basic understanding of customer situation - needs and opportunities'
    },{
      id: '103',
      stage: '1',
      imperativeId: null,
      text: 'Build rapport'
    },{
      id: '104',
      stage: '2',
      imperativeId: null,
      text: 'Deep understanding of prospect’s needs, pain points and organization'
    },{
      id: '105',
      stage: '2',
      imperativeId: null,
      text: 'Establish credibility of company and solution'
    },{
      id: '106',
      stage: '2',
      imperativeId: null,
      text: 'Create enthusiasm for ongoing prospect engagement'
    },{
      id: '107',
      stage: '2',
      imperativeId: null,
      text: 'Establish business imperatives for the partnership'
    },{
      id: '108',
      stage: '3',
      imperativeId: '1',
      text: 'I1: Who is the Buyer?',
    },{
      id: '109',
      stage: '3',
      imperativeId: '2',
      text: 'I2: Who are the Influencers?',
    },{
      id: '110',
      stage: '3',
      imperativeId: '3',
      text: 'I3: Who are we competing against and why?',
    },{
      id: '111',
      stage: '3',
      imperativeId: '4',
      text: 'I4: Why will we win?',
    },{
      id: '112',
      stage: '3',
      imperativeId: '5',
      text: 'I5: Why will we lose?',
    },{
      id: '113',
      stage: '3',
      imperativeId: '6',
      text: 'I6: When will decision be made?',
    },{
      id: '114',
      stage: '3',
      imperativeId: '7',
      text: 'I7: What have we taught them?',
    },{
      id: '115',
      stage: '3',
      imperativeId: null,
      text: 'Proposal presented',
    },{
      id: '116',
      stage: '4',
      imperativeId: null,
      imperativeTaskId: '612',
      text: 'Legal and procurement engaged'
    },{
      id: '117',
      stage: '4',
      imperativeId: null,
      text: 'Terms and fees negotiated'
    },{
      id: '118',
      stage: '4',
      imperativeId: null,
      text: 'Contract signed'
    }],

    reciprocations: [{
      id: '201',
      stage: '1',
      imperativeTaskId: null,
      text: 'Confirms interest and agrees to next step'
    },{
      id: '202',
      stage: '1',
      imperativeTaskId: null,
      text: 'Shares current situation'
    },{
      id: '203',
      stage: '2',
      imperativeTaskId: '112',
      text: 'Shares organizational goals and pain points'
    },{
      id: '204',
      stage: '2',
      imperativeTaskId: '113',
      text: 'Confirms initiative and budget'
    },{
      id: '205',
      stage: '2',
      //imperativeTaskId: '211',
      imperativeTaskId: null,
      text: 'Shares names and roles of key influencers'
    },{
      id: '206',
      stage: '2',
      imperativeTaskId: '415',
      text: 'Shares buying-decision-making process'
    },{
      id: '207',
      stage: '2',
      imperativeTaskId: '111',
      text: 'Confirms buyer'
    },{
      id: '208',
      stage: '3',
      imperativeTaskId: '215',
      text: 'Key influencer or buyer becomes an advisor'
    },{
      id: '209',
      stage: '3',
      imperativeTaskId: null,
      text: 'Provides business data to co-develop ROI/Value Proposition'
    },{
      id: '210',
      stage: '3',
      imperativeTaskId: '212',
      text: 'Gives access to all influencers'
    },{
      id: '211',
      stage: '3',
      imperativeTaskId: '115',
      text: 'Gives access to buyer'
    },{
      id: '212',
      stage: '3',
      imperativeTaskId: null,
      text: 'Shares alternatives being considered'
    },{
      id: '213',
      stage: '3',
      imperativeTaskId: '413',
      text: 'Shares win strategy'
    },{
      id: '214',
      stage: '3',
      imperativeTaskId: null,
      text: 'Verbal commitment to close'
    },{
      id: '215',
      stage: '4',
      imperativeTaskId: null,
      text: 'Assistance in completing closing docs'
    },{
      id: '216',
      stage: '4',
      imperativeTaskId: null,
      text: 'Access to all legal and procurement staff'
    }/*,{
      id: '217',
      stage: '4',
      imperativeTaskId: null,
      text: 'Kickoff date identified'
    }*/,{
      id: '218',
      stage: '4',
      imperativeTaskId: '613',
      text: 'Kickoff date agreed'
    }]
  }
}

// export function getDefaultOrganizationGoals(){
//   return {
//     behavior: [{
//       name: 'Problem Solver',
//       description: 'Problem Solver - You explore a range of options to find the best solution',
//       definition: '',
//       category: 'behavior',
//       goalType: 'do',
//       id: '100001'
//     },{
//       name: 'Collaborator',
//       description: 'Collaborator - You seek input to create a positive, open working enviornment',
//       definition: '',
//       category: 'behavior',
//       goalType: 'do',
//       id: '100002'
//     }],
//     skill: [{
//       name: 'Targeting',
//       description: 'Targeting',
//       definition: '',
//       category: 'skill',
//       goalType: 'do',
//       id: '200001'
//     },{
//       name: 'Opportunities',
//       description: 'Developing Opportunities',
//       definition: '',
//       category: 'skill',
//       goalType: 'do',
//       id: '200002'
//     },{
//       name: 'Planning',
//       description: 'Planning & Preparation',
//       definition: '',
//       category: 'skill',
//       goalType: 'do',
//       id: '200003'
//     },{
//       name: 'Conversations',
//       description: 'Productive Conversations',
//       definition: '',
//       category: 'skill',
//       goalType: 'do',
//       id: '200004'
//     },{
//       name: 'Executing',
//       description: 'Executing Sales Strategies',
//       definition: '',
//       category: 'skill',
//       goalType: 'do',
//       id: '200005'
//     },{
//       name: 'Relationships',
//       description: 'Developing Relationships',
//       definition: '',
//       category: 'skill',
//       goalType: 'do',
//       id: '200006'
//     },{
//       name: 'Closing',
//       description: 'Closing',
//       definition: '',
//       category: 'skill',
//       goalType: 'do',
//       id: '200007'
//     },{
//       name: 'Negotiating',
//       description: 'Negotiating',
//       definition: '',
//       category: 'skill',
//       goalType: 'do',
//       id: '200008'
//     },{
//       name: 'Account Management',
//       description: 'Account Management',
//       definition: '',
//       category: 'skill',
//       goalType: 'do',
//       id: '200009'
//     },{
//       name: 'Overcoming Objections',
//       description: 'Mastering Top 20 Objections',
//       definition: '',
//       category: 'skill',
//       goalType: 'do',
//       id: '200010'
//     },{
//       name: 'Demoing',
//       description: 'Running Effective Demos',
//       definition: '',
//       category: 'skill',
//       goalType: 'do',
//       id: '200011'
//     },{
//       name: 'PoV Presentation',
//       description: 'Presenting Company Point of View',
//       definition: '',
//       category: 'skill',
//       goalType: 'do',
//       id: '200012'
//     },{
//       name: 'ROI',
//       description: 'Developing ROI',
//       definition: '',
//       category: 'skill',
//       goalType: 'do',
//       id: '200013'
//     },{
//       name: 'Presenting Business Case',
//       description: 'Presenting Business Case',
//       definition: '',
//       category: 'skill',
//       goalType: 'do',
//       id: '200014'
//     },{
//       name: 'Imperatives',
//       description: 'Navigating 7 Imperatives',
//       definition: '',
//       category: 'skill',
//       goalType: 'do',
//       id: '200015'
//     }],
//     activity: [{
//       name: 'Calls',
//       description: 'Cold Calls (conversations)',
//       definition: '',
//       category: 'activity',
//       goalType: 'measure',
//       id: '300001'
//     },{
//       name: 'Demos',
//       description: 'Client Demos',
//       definition: '',
//       category: 'activity',
//       goalType: 'measure',
//       id: '300002'
//     },{
//       name: 'RFPs',
//       description: 'RFPs',
//       definition: '',
//       category: 'activity',
//       goalType: 'measure',
//       id: '300003'
//     },{
//       name: 'Meetings',
//       description: 'In Person Meetings',
//       definition: '',
//       category: 'activity',
//       goalType: 'measure',
//       id: '300004'
//     },{
//       name: 'Proposals',
//       description: 'Proposals',
//       definition: '',
//       category: 'activity',
//       goalType: 'measure',
//       id: '300005'
//     }],
//     outcome: [{
//       name: 'Quota',
//       description: 'Quarterly Sales Quota',
//       definition: '',
//       category: 'outcome',
//       goalType: 'forecast',
//       id: '400001'
//     }],
//   };
// }

//FOR GP STRATEGIES
export function getDefaultOrganizationGoals(){
  return {
    behavior: [{
      name: 'Ambition',
      description: 'Leads with consistency and objectivity through defined, measurable performance criteria.',
      definition: 'Leads with consistency and objectivity through defined, measurable performance criteria.',
      category: 'behavior',
      goalType: 'do',
      id: '100001',
    },{
      name: 'Confidence',
      description: 'Sets high standards and applies rigorous talent and coaching practices to maximize growth through people.',
      definition: 'Sets high standards and applies rigorous talent and coaching practices to maximize growth through people.',
      category: 'behavior',
      goalType: 'do',
      id: '100002',
    },{
      name: 'Competition',
      description: 'Driven to be better than others.  Inspires team desire to compete through consistent focus on how we will win.',
      definition: 'Driven to be better than others.  Inspires team desire to compete through consistent focus on how we will win.',
      category: 'behavior',
      goalType: 'do',
      id: '100003',
    },{
      name: 'Persistence',
      description: 'Applies Increased effort & tenacity in the face of resistance to reach a goal.',
      definition: 'Applies Increased effort & tenacity in the face of resistance to reach a goal.',
      category: 'behavior',
      goalType: 'do',
      id: '100004',
    },{
      name: 'Networker',
      description: 'Initiates relationships & qualifies prospects through engaging in conversation, then establishing rapport.',
      definition: 'Initiates relationships & qualifies prospects through engaging in conversation, then establishing rapport.',
      category: 'behavior',
      goalType: 'do',
      id: '100005',
    },{
      name: 'Relator',
      description: 'Builds authentic friendships by demonstrating care & concern for associate & customer needs.',
      definition: 'Builds authentic friendships by demonstrating care & concern for associate & customer needs.',
      category: 'behavior',
      goalType: 'do',
      id: '100006',
    },{
      name: 'Advisor',
      description: 'Derives significant satisfaction from contributing to the growth and success of customers. ',
      definition: 'Derives significant satisfaction from contributing to the growth and success of customers. ',
      category: 'behavior',
      goalType: 'do',
      id: '100007',
    },{
      name: 'Collaborator',
      description: 'Aligns efforts through complementary work streams and collaboration in reaching a common goal.',
      definition: 'Aligns efforts through complementary work streams and collaboration in reaching a common goal.',
      category: 'behavior',
      goalType: 'do',
      id: '100008',
    },{
      name: 'Individualizer',
      description: 'Listens and understands buyer’s needs, emotions, and desires to deliver a value through offering.',
      definition: 'Listens and understands buyer’s needs, emotions, and desires to deliver a value through offering.',
      category: 'behavior',
      goalType: 'do',
      id: '100009',
    },{
      name: 'Analytical',
      description: 'Reviews patterns in data and commercials to evaluate opportunities, illuminate compelling differences from competitors, anticipate future needs, and improve win plans.',
      definition: 'Reviews patterns in data and commercials to evaluate opportunities, illuminate compelling differences from competitors, anticipate future needs, and improve win plans.',
      category: 'behavior',
      goalType: 'do',
      id: '100010',
    },{
      name: 'Adaptability',
      description: 'Modifies approach to position offering to serve unique requirements and constraints of buyer.',
      definition: 'Modifies approach to position offering to serve unique requirements and constraints of buyer.',
      category: 'behavior',
      goalType: 'do',
      id: '100011',
    },{
      name: 'Learning Agility',
      description: 'Routinely gathers information and knowledge from credible sources in order to build expertise and value to customer.',
      definition: 'Routinely gathers information and knowledge from credible sources in order to build expertise and value to customer.',
      category: 'behavior',
      goalType: 'do',
      id: '100012',
    },{
      name: 'Problem Solver',
      description: 'Uncovers root cause, explores alternatives, evaluates consequences, and applies creative resolutions.',
      definition: 'Uncovers root cause, explores alternatives, evaluates consequences, and applies creative resolutions.',
      category: 'behavior',
      goalType: 'do',
      id: '100013',
    },{
      name: 'Focus',
      description: 'Sets clear goals and maintains consistent direction for continual progress towards priority outcomes.',
      definition: 'Sets clear goals and maintains consistent direction for continual progress towards priority outcomes.',
      category: 'behavior',
      goalType: 'do',
      id: '1000014',
    },{
      name: 'Accountability',
      description: 'Shows dedication, commitment and ownership when executing tasks.',
      definition: 'Shows dedication, commitment and ownership when executing tasks.',
      category: 'behavior',
      goalType: 'do',
      id: '100015',
    },{
      name: 'Persuasion',
      description: 'Naturally takes command, addresses conflict, and asserts perspective. Gains agreement from others via logic and alternatives.',
      definition: 'Naturally takes command, addresses conflict, and asserts perspective. Gains agreement from others via logic and alternatives.',
      category: 'behavior',
      goalType: 'do',
      id: '100016',
    },{
      name: 'Discipline',
      description: 'Highly structured and attentive to detail. Plans ahead and manages schedule to deliver on time.',
      definition: 'Highly structured and attentive to detail. Plans ahead and manages schedule to deliver on time.',
      category: 'behavior',
      goalType: 'do',
      id: '100017',
    }],
    /*
  },{
    name: '',
    description: '',
    definition: '',
    category: 'behavior',
    goalType: 'do',
    id: '100004',
  },{
    name: '',
    description: '',
    definition: '',
    category: 'behavior',
    goalType: 'do',
    id: '100005',
  },{
    name: '',
    description: '',
    definition: '',
    category: 'behavior',
    goalType: 'do',
    id: '100006',
  },{
    name: '',
    description: '',
    definition: '',
    category: 'behavior',
    goalType: 'do',
    id: '100007',
  },{
    name: '',
    description: '',
    definition: '',
    category: 'behavior',
    goalType: 'do',
    id: '100008',
  },{
    name: '',
    description: '',
    definition: '',
    category: 'behavior',
    goalType: 'do',
    id: '100009',
  },{
    name: '',
    description: '',
    definition: '',
    category: 'behavior',
    goalType: 'do',
    id: '100010',
  },{
    name: '',
    description: '',
    definition: '',
    category: 'behavior',
    goalType: 'do',
    id: '100011',
  },{
    name: '',
    description: '',
    definition: '',
    category: 'behavior',
    goalType: 'do',
    id: '100012',
  },{
    name: '',
    description: '',
    definition: '',
    category: 'behavior',
    goalType: 'do',
    id: '100013',
  },{
    name: '',
    description: '',
    definition: '',
    category: 'behavior',
    goalType: 'do',
    id: '1000014',
  },{
    name: '',
    description: '',
    definition: '',
    category: 'behavior',
    goalType: 'do',
    id: '100015',
  },{
    name: '',
    description: '',
    definition: '',
    category: 'behavior',
    goalType: 'do',
    id: '100016',
  }],
  */

    skill: [
      /*
    {
      name: 'Operational Excellence',
      description: 'Demonstrates Expert Knowledge of customer needs and market drivers for Operational Excellence, as well as GP’s comprehensive product and services offerings and our consultative sales approach.',
      definition: 'Demonstrates Expert Knowledge of customer needs and market drivers for Operational Excellence, as well as GP’s comprehensive product and services offerings and our consultative sales approach.',
      category: 'skill',
      goalType: 'do',
      id: '200001',
      ratings: []
    },{
      name: 'Asset Performance Management',
      description: 'Demonstrates Expert Knowledge of customer needs and market drivers for Asset Performance Management, as well as GP’s comprehensive product and services offerings and our consultative sales approach.',
      definition: 'Demonstrates Expert Knowledge of customer needs and market drivers for Asset Performance Management, as well as GP’s comprehensive product and services offerings and our consultative sales approach.',
      category: 'skill',
      goalType: 'do',
      id: '200002'
    },{
      name: 'Learning & Development',
      description: 'Demonstrates Expert Knowledge of customer needs and market drivers for Technical and non-technical Learning & Development needs, as well as GP’s comprehensive product, services, e-Learning, instructor-led training, hands-on training, and virtual instructor-led training, offerings.  * Includes GP’s approach to custom learning & development programs, and GPiLEARN+ capabilities and content.',
      definition: 'Demonstrates Expert Knowledge of customer needs and market drivers for Technical and non-technical Learning & Development needs, as well as GP’s comprehensive product, services, e-Learning, instructor-led training, hands-on training, and virtual instructor-led training, offerings.  * Includes GP’s approach to custom learning & development programs, and GPiLEARN+ capabilities and content.',
      category: 'skill',
      goalType: 'do',
      id: '200003'
    },{
      name: 'EtaPRO Performance and Condition Monitoring',
      description: 'Demonstrates Basic Understanding of thermal performance monitoring and asset condition monitoring.  Understanding of customer needs and market drivers for monitoring and diagnostics at power plants, refineries, and in technical industries.  Understanding of EtaPRO and its suite of technologies (Virtual Plant, Advanced Pattern Recognition, Predictor, EPArchive).  Ability to develop customer specific business case for justification of investment into EtaPRO',
      definition: 'Demonstrates Basic Understanding of thermal performance monitoring and asset condition monitoring.  Understanding of customer needs and market drivers for monitoring and diagnostics at power plants, refineries, and in technical industries.  Understanding of EtaPRO and its suite of technologies (Virtual Plant, Advanced Pattern Recognition, Predictor, EPArchive).  Ability to develop customer specific business case for justification of investment into EtaPRO',
      category: 'skill',
      goalType: 'do',
      id: '200004'
    },{
      name: 'Leadership Development & Employee Engagement',
      description: 'Demonstrates Expert Knowledge of customer needs and market drivers for Leadership Development and employee engagement, as well as GP’s comprehensive service offerings via BlessingWhite.',
      definition: 'Demonstrates Expert Knowledge of customer needs and market drivers for Leadership Development and employee engagement, as well as GP’s comprehensive service offerings via BlessingWhite.',
      category: 'skill',
      goalType: 'do',
      id: '200005'
    },{
      name: 'Organizational Change Management',
      description: 'Demonstrates Expert Knowledge of customer needs regarding Organizational Change Management, and the business drivers around culture change, as well as GP’s OCM service offerings.',
      definition: 'Demonstrates Expert Knowledge of customer needs regarding Organizational Change Management, and the business drivers around culture change, as well as GP’s OCM service offerings.',
      category: 'skill',
      goalType: 'do',
      id: '200006'
    },{
      name: 'Platform Adoption',
      description: 'Demonstrates Expert Knowledge of customer needs and market drivers for digital transformation and large technology and software deployment, as well as GP’s Platform Adoption services.  This includes our capabilities with SAP, SucceesFactors, Cornerstone, and other ERP and Learning & Development support services.',
      definition: 'Demonstrates Expert Knowledge of customer needs and market drivers for digital transformation and large technology and software deployment, as well as GP’s Platform Adoption services.  This includes our capabilities with SAP, SucceesFactors, Cornerstone, and other ERP and Learning & Development support services.',
      category: 'skill',
      goalType: 'do',
      id: '200007'
    },{
      name: 'Competition',
      description: 'Demonstrates Expert Knowledge of GP Strategies competition for our varied product and service offerings.  Articulates the competitive value proposition, and how we position GP Strategies to win each competitive engagement.',
      definition: 'Demonstrates Expert Knowledge of GP Strategies competition for our varied product and service offerings.  Articulates the competitive value proposition, and how we position GP Strategies to win each competitive engagement.',
      category: 'skill',
      goalType: 'do',
      id: '200008'
    },{
      name: 'Industry Knowledge',
      description: 'Demonstrates Expert Knowledge of trends, regulations, emerging technologies, and other factors that affect the EOG markets and our customer’s strategic direction, tactics, funded projects, and overall ability to spend.',
      definition: 'Demonstrates Expert Knowledge of trends, regulations, emerging technologies, and other factors that affect the EOG markets and our customer’s strategic direction, tactics, funded projects, and overall ability to spend.',
      category: 'skill',
      goalType: 'do',
      id: '200009'
    },{
      name: 'Customer Knowledge',
      description: 'Demonstrates Expert Knowledge of varied business structures, organizational structures, and their place in the EOG industries.  Incorporates this knowledge to effectively review public information, and engage customer contact to learn about their strategic direction and business plans.  Ability to consume this data and determine winning strategies to grow key customers.',
      definition: 'Demonstrates Expert Knowledge of varied business structures, organizational structures, and their place in the EOG industries.  Incorporates this knowledge to effectively review public information, and engage customer contact to learn about their strategic direction and business plans.  Ability to consume this data and determine winning strategies to grow key customers.',
      category: 'skill',
      goalType: 'do',
      id: '200010'
    }*/
    {
      name: 'Negotiation Skills',
      description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum faucibus consequat nunc. Maecenas egestas arcu id felis malesuada feugiat. Quisque ullamcorper pharetra eros eget vulputate. Nam euismod sit amet magna ac scelerisque. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. Nunc eget consectetur magna. Vestibulum ornare eu libero a ultricies.',
      definition: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum faucibus consequat nunc. Maecenas egestas arcu id felis malesuada feugiat. Quisque ullamcorper pharetra eros eget vulputate. Nam euismod sit amet magna ac scelerisque. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. Nunc eget consectetur magna. Vestibulum ornare eu libero a ultricies.',
      category: 'skill',
      goalType: 'do',
      id: '200001'
    },
    {
      name: 'Presentation & Meeting skills',
      description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum faucibus consequat nunc. Maecenas egestas arcu id felis malesuada feugiat. Quisque ullamcorper pharetra eros eget vulputate. Nam euismod sit amet magna ac scelerisque. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. Nunc eget consectetur magna. Vestibulum ornare eu libero a ultricies.',
      definition: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum faucibus consequat nunc. Maecenas egestas arcu id felis malesuada feugiat. Quisque ullamcorper pharetra eros eget vulputate. Nam euismod sit amet magna ac scelerisque. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. Nunc eget consectetur magna. Vestibulum ornare eu libero a ultricies.',
      category: 'skill',
      goalType: 'do',
      id: '200002'
    },
    {
      name: 'Platform Adoption',
      description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum faucibus consequat nunc. Maecenas egestas arcu id felis malesuada feugiat. Quisque ullamcorper pharetra eros eget vulputate. Nam euismod sit amet magna ac scelerisque. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. Nunc eget consectetur magna. Vestibulum ornare eu libero a ultricies.',
      definition: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum faucibus consequat nunc. Maecenas egestas arcu id felis malesuada feugiat. Quisque ullamcorper pharetra eros eget vulputate. Nam euismod sit amet magna ac scelerisque. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. Nunc eget consectetur magna. Vestibulum ornare eu libero a ultricies.',
      category: 'skill',
      goalType: 'do',
      id: '200003'
    },
    {
      name: 'Sales Process',
      description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum faucibus consequat nunc. Maecenas egestas arcu id felis malesuada feugiat. Quisque ullamcorper pharetra eros eget vulputate. Nam euismod sit amet magna ac scelerisque. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. Nunc eget consectetur magna. Vestibulum ornare eu libero a ultricies.',
      definition: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum faucibus consequat nunc. Maecenas egestas arcu id felis malesuada feugiat. Quisque ullamcorper pharetra eros eget vulputate. Nam euismod sit amet magna ac scelerisque. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. Nunc eget consectetur magna. Vestibulum ornare eu libero a ultricies.',
      category: 'skill',
      goalType: 'do',
      id: '200004'
    },
    {
      name: 'Proposal Writing',
      description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum faucibus consequat nunc. Maecenas egestas arcu id felis malesuada feugiat. Quisque ullamcorper pharetra eros eget vulputate. Nam euismod sit amet magna ac scelerisque. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. Nunc eget consectetur magna. Vestibulum ornare eu libero a ultricies.',
      definition: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum faucibus consequat nunc. Maecenas egestas arcu id felis malesuada feugiat. Quisque ullamcorper pharetra eros eget vulputate. Nam euismod sit amet magna ac scelerisque. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. Nunc eget consectetur magna. Vestibulum ornare eu libero a ultricies.',
      category: 'skill',
      goalType: 'do',
      id: '200005'
    },
  ],

    activity: [{
      name: 'Cold Calls',
      description: 'Cold Calls',
      definition: '',
      category: 'activity',
      goalType: 'measure',
      id: '300001'
    },{
      name: 'Discovery Calls',
      description: 'Discovery Calls',
      definition: '',
      category: 'activity',
      goalType: 'measure',
      id: '300002'
    },{
      name: 'Presentations',
      description: 'Presentations',
      definition: '',
      category: 'activity',
      goalType: 'measure',
      id: '300003'
    },{
      name: 'Executive Meetings',
      description: 'Executive Meetings',
      definition: '',
      category: 'activity',
      goalType: 'measure',
      id: '300004'
    },{
      name: 'Proposals',
      description: 'Proposals',
      definition: '',
      category: 'activity',
      goalType: 'measure',
      id: '300005'
    },{
      name: 'Active Pipeline',
      description: 'Active Pipeline',
      definition: '',
      category: 'activity',
      goalType: 'measure',
      id: '300006',
    }],

    outcome: [{
      name: 'Quota',
      description: 'Quarterly Sales Quota',
      definition: '',
      category: 'outcome',
      goalType: 'forecast',
      id: '400001'
    }],
  };
}



//OLD functions for getting scoring data for profiles
export function getUserStrengthsFromAllScores(userId, allScoreData){
  const userScoreData = _.find(allScoreData, scoreDataForUser => {
    return parseInt(scoreDataForUser.ProfileID) === parseInt(userId);
  });

  console.log('userScoreData: %o', userScoreData);

  if(!userScoreData){
    return false;
  }

  let scoresForUser = {};
  let totalScoreForUser = 0;

  _.each(TALENT_CATEGORIES, function(talentCategory){

    scoresForUser[talentCategory] = {};

    let talentCategoryTotal = 0;

    //go through each component and add to talent category total + set "raw" score value
    _.each(getCategoryComponents(talentCategory), function(componentName){
      scoresForUser[talentCategory][componentName] = {};
      const scoreForComponent = userScoreData[getDimensionIdForTalent(componentName)];

      console.log('userScoreData: %o', userScoreData);
      console.log('componentName: %o', getDimensionIdForTalent(componentName));
      console.log('scoreForComponent: %o', scoreForComponent);

      talentCategoryTotal += scoreForComponent;
      scoresForUser[talentCategory][componentName]['raw'] = scoreForComponent;
    });

    _.each(getCategoryComponents(talentCategory), function(componentName){
      const scoreForComponent = userScoreData[getDimensionIdForTalent(componentName)];
      scoresForUser[talentCategory][componentName]['percent'] = scoreForComponent * 100 / talentCategoryTotal;
    });

    scoresForUser[talentCategory]['raw'] = talentCategoryTotal;
    totalScoreForUser += talentCategoryTotal;
  });

  _.each(TALENT_CATEGORIES, function(talentCategory){
    scoresForUser[talentCategory]['percent'] = scoresForUser[talentCategory].raw * 100 / totalScoreForUser;
  });

  //console.log('scoresForUser: ', scoresForUser);

  //let allScoresTotal = _.reduce(userScoreData, function())

  return scoresForUser;
}

export function getOrderedUserStrengthsFromAllScores(userId, allScoreData){
  const userScoreData = getUserStrengthsFromAllScores(userId, allScoreData);

  if(!userScoreData){
    return false;
  }

  let talentCategoriesArray = [];

  _.each(TALENT_CATEGORIES, function(categoryId){

    talentCategoriesArray.push({
      id: categoryId,
      name: toTitleCase(categoryId),
      raw: userScoreData[categoryId].raw,
      percent: userScoreData[categoryId].percent,
    });
  });

  const sortedTalentCategoriesArray = _.sortBy(talentCategoriesArray, function(talentCategory){
    return -1 * talentCategory.percent;
  });

  _.each(sortedTalentCategoriesArray, function(talentCategory){

    let talentCategoryTalents = [];

    _.each(getCategoryComponents(talentCategory.id), function(componentName){

      talentCategoryTalents.push({
        id: componentName,
        name: toTitleCase(componentName),
        ...userScoreData[talentCategory.id][componentName]
      });
    });

    const sortedTalentCategoryTalents = _.sortBy(talentCategoryTalents, function(talentScores){
      return -1 * talentScores.percent;
    });

    talentCategory.talents = sortedTalentCategoryTalents;
  });

  console.log(sortedTalentCategoriesArray);

  return sortedTalentCategoriesArray;
}

export function getUserDataFromAllUsers(userId, allUserData){
  const userData = _.find(allUserData, person => {
    return parseInt(person.ProfileID) === parseInt(userId);
  });

  return userData;
}



// WEBPACK FOOTER //
// ./src/util/data.js